export const LANDING_URL = 'https://www.adok.ai'

export const TERMS_URL = `${LANDING_URL}/terms-and-conditions`

export const CAPTCHA_SITE_KEY = String(import.meta.env.VITE_CAPTCHA_KEY ?? '')
